import { NewsItem } from "../../../api/newsfeed.types";
import { NewsItemAction } from "./news.item.types";

export const newsItemRequestAction = (params: { news_id: number }): NewsItemAction => ({ type: 'NEWS_ITEM_REQUEST', params })
export const newsItemSuccessAction = (item: NewsItem): NewsItemAction => ({ type: 'NEWS_ITEM_SUCCESS', params: item })
export const newsItemFailureAction = (error?: any): NewsItemAction => ({ type: 'NEWS_ITEM_FAILURE', params: error })